import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, twitter } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#A00F0F" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center color="#58595B" bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/p/Hanabi-Japanese-Restaurant-100092428921617/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Hanabi Sushi Facebook"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/hanabi.battleford/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Hanabi Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#A00F0F" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter color="#58595B" bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/p/Hanabi-Japanese-Restaurant-100092428921617/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Hanabi Sushi Instagram"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/hanabi.battleford/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Hanabi Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
